import styled from 'styled-components';
import Text from './Text';
var Bold = styled(Text).attrs(function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'strong' : _ref$as;
  return {
    as: as
  };
}).withConfig({
  displayName: "Bold",
  componentId: "sc-k6jrb6-0"
})(["font-weight:700;"]);
export default Bold;